import { useQuery } from '@tanstack/react-query';
import { getAvailableInspectionsCount } from '../services/AIInspectionManagerService';
export default function useAvailableInspectionsCount(days, options = { enabled: true }) {
    return useQuery(['availableInspectionsCount', days], () => getAvailableInspectionsCount(days), {
        staleTime: 30 * 1000,
        cacheTime: 5 * 60 * 1000,
        enabled: days > 0 && options.enabled
    });
}
